<template>
	<Tab
		class="athlete-tags"
		:tabs="tabs"
		:icon-size="`lg`"
		:active-tab="activeTab"
		@tab-change="$emit('tab-change', $event)"
	>
		<template #tab-details-event-tags>
			<TagGrid
				:items="eventTargetTags"
				:selected-items="selectedItems"
				:sport-name="sportName"
				:can-select="true"
				:swipable="isMobileWebApp"
				:enable-recycler-view="true"
				:recycler-page-size="25"
				:empty-msg="transUcfirst('commons.no_types_found', { type: 'tags' })"
				:swipe-left-options="{ icon: 'network-communication', action: handleShare }"
				:swipe-right-options="{ icon: 'bin', action: handleDelete }"
				:checkbox-always-visible="checkboxAlwaysVisible"
				:show-participant="false"
				@row-click="handleRowClick"
				@selection-changed="handleSelectionChanged"
			/>
		</template>
		<template #tab-details-athlete-tags>
			<div class="athlete-wrapper">
				<MobileAthleteSelector
					v-if="isMobileWebApp"
					:athletes="eventParticipants"
					:value="athleteDropdownValue"
					:has-all-option="true"
					@input="setSelectedAthlete"
				/>
				<AthleteSelector
					v-if="!isMobileWebApp"
					:athletes="eventParticipants"
					:value="athleteDropdownValue"
					:has-all-option="true"
					@input="setSelectedAthlete"
				/>
				<AthletesTagList
					:athlete="selectedAthlete"
					:all-athlete-tags="athleteTargetTags"
					:can-select="true"
					:swipable="isMobileWebApp"
					:empty-msg="transUcfirst('commons.no_types_found', { type: 'tags' })"
					:checkbox-always-visible="checkboxAlwaysVisible"
					:sort-dir="sortDir"
					@row-click="handleRowClick"
					@selection-changed="handleSelectionChanged"
				/>
			</div>
		</template>
	</Tab>
</template>

<script>
/* eslint-disable vue/one-component-per-file */
import { mapActions, mapGetters } from 'vuex';
import TagGrid from './TagGrid';
import Tab from '@components/tab/Tab';
import MobileAthleteSelector from '@videotools/js/one/components/AthleteSelector/MobileAthleteSelector';
import AthleteSelector from '@videotools/js/one/components/AthleteSelector/AthleteSelector';
import AthletesTagList from '@videotools/js/one/components/TagList/AthletesTagList';
import { ATHLETE_ALL_KEY, TAB_ATHLETE_TAGS, TAB_EVENT_TAGS } from '@videotools/js/constants/athletes';

export default {
	name:       'RaceSportTagList',
	components: { AthletesTagList, AthleteSelector, MobileAthleteSelector, Tab, TagGrid },
	props:      {
		canSelect: {
			type:    Boolean,
			default: true,
		},
		checkboxAlwaysVisible: {
			type:    Boolean,
			default: false,
		},
		eventTargetTags: {
			type:    Array,
			default: () => [],
		},
		athleteTargetTags: {
			type:    Array,
			default: () => [],
		},
		sortDir: {
			type:    String,
			default: 'desc',
		},
		activeTab: {
			default: null,
		},
	},
	data() {
		return {
			athleteDropdownValue: ATHLETE_ALL_KEY,
			tags:                 [],
			selectedItems:        [],
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp:    'app/isMobileWebApp',
			event:             'event/event',
			sportName:         'event/sportName',
			isVod:             'event/isVod',
			sorting:           'tags/sorting',
			eventParticipants: 'event/participants',
		}),
		tabs() {
			return [
				{
					key:   TAB_EVENT_TAGS,
					label: this.transChoiceUcFirst('commons.event', 1),
					icon:  'calendar',
				},
				{
					key:   TAB_ATHLETE_TAGS,
					label: this.transChoiceUcFirst('commons.athlete', 1),
					icon:  'users-wm',
				},
			];
		},
		selectedAthlete() {
			return this.athleteDropdownValue === ATHLETE_ALL_KEY ? null : this.athleteDropdownValue;
		},
	},
	methods: {
		...mapActions({
			updateActiveEventTagFilters:   'tagFilters/updateActiveFilters',
			updateActiveAthleteTagFilters: 'athleteTagFilters/updateActiveFilters',
			setSorting:                    'tagFilters/setSorting',
			setExcludedTags:               'tagFilters/setExcludedTags',
		}),
		handleRowClick(row) {
			this.$emit('row-click', row);
		},
		handleSelectionChanged(selected) {
			this.$emit('selection-changed', selected);
		},
		handleDelete(item) {
			this.$emit('on-delete', item);
		},
		handleShare(item) {
			this.$emit('on-share', item);
		},
		setSelectedAthlete(value) {
			this.athleteDropdownValue = value;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.tag-list-ct {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.footer {
	width: 100%;
}

.actions {
	display: flex;
	gap: $sp5;
}

.athlete-tags::v-deep {
	.tabs li {
		padding: 16px;
		background: var(--color-grey-950);

		&.is-active {
			background: var(--color-grey-900);
			border-bottom: none;
		}
	}

	.tab-details {
		background: var(--color-grey-900);
	}
}

.athlete-wrapper {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: var(--color-grey-900);

	.athlete-selector {
		padding: 24px;
	}

	::v-deep .list--container .thead {
		border-top: 1px solid var(--color-grey-800);
	}
}
</style>
